export const SET_MODAL_VISIBLE = 'SET_MODAL_VISIBLE'
export const SET_LINKING_STATUS_CODE = 'SET_LINKING_STATUS_CODE'
export const SET_REQUEST_LOADING = 'SET_REQUEST_LOADING'
export const SET_HAS_ERROR_LINKING = 'SET_HAS_ERROR_LINKING'
export const SET_SUCCESS_LINKING = 'SET_SUCCESS_LINKING'
export const SET_API_ERROR_EMAIL = 'SET_API_ERROR_EMAIL'
export const SET_API_ERROR_PASSWORD = 'SET_API_ERROR_PASSWORD'
export const SET_API_ERROR_GLOBAL = 'SET_API_ERROR_GLOBAL'
export const CLEAR_API_ERRORS = 'CLEAR_API_ERRORS'
